import { Suspense } from 'react';
import MtSpinner from '../components/AppLoader/MtSpinner';

export const renderLazyComponent =
  (Component: React.ComponentType<any>, loader = <MtSpinner />) =>
  (props: any = {}) =>
    (
      <Suspense fallback={loader}>
        <Component {...props} />
      </Suspense>
    );

export const isMobileWebView = () =>
  window.navigator.userAgent.indexOf('MTWebView') > -1;

export const waitFor = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
